import React, { forwardRef } from "react";
import {
 
  Paper,
 
} from "@mui/material";

const PrintableForm = forwardRef(({ driver }, ref) => {
  return (
    <Paper ref={ref}  sx={{ p: { xs: 2, sm: 3 }, borderRadius: 4, boxShadow: 6 }}>
    <div style={{ fontFamily: "Noto Sans Devanagari, sans-serif", padding: 20, lineHeight: 1.8 }}>
      <h2 style={{ textAlign: "center", marginBottom: 20 }}>चरित्र सत्यापन प्रपत्र</h2>

      <div style={{ float: "right", width: 120, height: 150, border: "1px solid #000", textAlign: "center" }}>
        {driver?.upload_photo ? (
          <img src={driver.upload_photo} alt="driver" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        ) : (
          "आवेदक का फोटो"
        )}
      </div>

      <p>1. आवेदक का नाम : {driver.contact_person}</p>
      <p>2. पिता / पति का नाम : {driver.father_name||driver.contact_person}</p>
      <p>3. आवेदक की वर्तमान संस्था का पता : {driver.present_address1}</p>
      <p>4. आवेदक वर्तमान में संस्था में किस पद पर कार्यरत है : {driver.designation}</p>
      <p>5. आवेदक का वर्तमान पता : {driver.present_address1}</p>
      <p>6. आवेदक का स्थायी पता : {driver.present_address1}</p>
      <p>7. गत पाँच वर्ष में रहने का पता : {driver.present_address1}</p>
      <p>8. आवेदक की जन्म तिथि : {driver.date_birth}</p>
      <p>9. आवेदक का मोबाइल नम्बर : {driver.mobile1}</p>
      <p>10. आवेदक का आधार कार्ड नम्बर : {driver.aadhaar_no}</p>
      <p>11. संस्था में कब से कार्यरत है : {driver.school_level1_datetime}</p>
      <p>12. पूर्व में किस संस्था में कार्यरत था : {driver.school_level1_datetime}</p>
      <p>13. आवेदक का ड्राइविंग लाइसेंस का प्रकार एवं लाइसेंस नम्बर : {driver.dl_type}</p>

      <br /><br />
      <p>आवेदक का नाम, पता एवं हस्ताक्षर</p>
      <p style={{ float: "right" }}>प्राचार्य का नाम, पता, हस्ताक्षर एवं सील</p>
    </div>
    </Paper>
  );
});

export default PrintableForm;
